var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGivingBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 117.9 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--giving",
    x1: 0.5,
    y1: -460.99,
    x2: 31.5,
    y2: -460.99,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -444.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2b327"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "giving-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,16c0,12.4-3.1,15.5-15.5,15.5S.5,28.4.5,16,3.6.5,16,.5,31.5,3.6,31.5,16Z",
    fill: "url(#linear-gradient--giving)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,21.9a.9.9,0,0,1-1,0c-1.9-1.4-9.3-7-5.1-10.7a3.8,3.8,0,0,1,5.1.4l.5.5.5-.5a3.7,3.7,0,0,1,5-.4C25.8,14.9,18.4,20.5,16.5,21.9Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.8,7.5h-.9c-.6,0-.7.4-.8.7l-.3.7A7.4,7.4,0,0,0,47,7.2c-4.2,0-7.5,3.6-7.5,8.2s3.4,8.3,7.7,8.3a7.9,7.9,0,0,0,3.7-1v.5c0,3.3-2,4-3.6,4a5,5,0,0,1-3.5-1.4,1.1,1.1,0,0,0-.8-.2,1.2,1.2,0,0,0-.5.5l-.8,1.5a.8.8,0,0,0,.2,1.1,8.7,8.7,0,0,0,5.4,1.9c4.6,0,7.4-2.8,7.4-7.4V8.4A.9.9,0,0,0,53.8,7.5ZM51,12.8V19a7,7,0,0,1-3.4,1.2,4.8,4.8,0,0,1-4.4-4.8,4.2,4.2,0,0,1,3.7-4.6A4.1,4.1,0,0,1,51,12.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6.5a2.4,2.4,0,0,0-2.4,2.4h0a2.3,2.3,0,0,0,2.3,2.4h.1a2.5,2.5,0,0,0,0-4.9Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6,7.5h1.9a.9.9,0,0,1,.9.9v14a.9.9,0,0,1-.9.9H58.6a.9.9,0,0,1-.9-.9V8.4a.9.9,0,0,1,.9-.9Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2,7.5H75.7a1.2,1.2,0,0,0-1.2.5l-4.1,9.2L66.4,8a1.1,1.1,0,0,0-.9-.5h-2a.9.9,0,0,0-.8.4.6.6,0,0,0,.1.7l6.7,14.6a.8.8,0,0,0,.8.5h.2a1,1,0,0,0,.8-.5L78,8.6a.9.9,0,0,0,0-.7A.9.9,0,0,0,77.2,7.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2.5a2.4,2.4,0,0,0-2.4,2.4h0A2.4,2.4,0,1,0,81.2.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3,7.5h1.8a1,1,0,0,1,1,.9v14a1,1,0,0,1-1,.9H80.3a.9.9,0,0,1-.9-.9V8.4A.9.9,0,0,1,80.3,7.5Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1,7.2a6.9,6.9,0,0,0-5.1,2l-.4-1.1a.8.8,0,0,0-.8-.6H87a.9.9,0,0,0-.9.9v14a.9.9,0,0,0,.9.9h1.7c.7,0,1.1-.3,1.1-.9V12.8a4.6,4.6,0,0,1,3.9-2.1c1.8,0,2.8,1.4,2.8,3.8v7.9a1,1,0,0,0,1,.9h1.8a.9.9,0,0,0,.9-.9V14.6C100.2,9.6,98.2,7.2,94.1,7.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5,7.5h-.9c-.6,0-.7.4-.8.7l-.3.7a7.4,7.4,0,0,0-4.8-1.7c-4.2,0-7.5,3.6-7.5,8.2s3.4,8.3,7.7,8.3a7.9,7.9,0,0,0,3.7-1v.5c0,3.3-2,4-3.6,4a5,5,0,0,1-3.5-1.4,1.1,1.1,0,0,0-.8-.2,1.2,1.2,0,0,0-.5.5l-.8,1.5a.9.9,0,0,0,.2,1.1,8.7,8.7,0,0,0,5.4,1.9c4.6,0,7.4-2.8,7.4-7.4V8.4A.9.9,0,0,0,116.5,7.5Zm-2.8,5.3V19a7,7,0,0,1-3.4,1.2,4.8,4.8,0,0,1-4.4-4.8,4.2,4.2,0,0,1,3.7-4.6A4.1,4.1,0,0,1,113.7,12.8Z",
    fill: "#444"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGivingBadgeColor);
export default __webpack_public_path__ + "static/media/giving-badge-color.13fc401d55f6f7e8dd33d0b1b7d5fc2d.svg";
export { ForwardRef as ReactComponent };